import { useQuery } from '@tanstack/react-query';
import { fetchConfigDoor, fetchStoreOpeningState } from '../queries/door.queries';

export const useConfigDoor = (storeId: number) => {
    return useQuery({
        queryKey: ['doorConfig', storeId],
        queryFn: () => {
            return fetchConfigDoor(storeId);
        },
    });
};

export const useStoreOpeningState = (storeId: number) => {
    return useQuery({
        queryKey: ['storeOpeningState', storeId],
        queryFn: () => {
            return fetchStoreOpeningState(storeId);
        },
    });
};
